export default __webpack_public_path__ + "static/media/sauna2.2b3ace68.png";